import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { faqs } from '../data/megaPack';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-cream-100 py-10 sm:py-20" aria-labelledby="preguntas-frecuentes" data-id="element-83" data-mp="1gdgyj9bric0m">
      <div className="mx-auto max-w-3xl px-5 sm:px-8" data-id="element-84" data-mp="2e0zep57r6gen">
        <SectionHeading eyebrow="Dudas comunes" title="Preguntas frecuentes" data-id="element-85" data-mp="2dyd93b4faaz2" />

        <ul className="mt-6 divide-y divide-teal-900/10 border-y border-teal-900/10 sm:mt-10" data-id="element-86" data-mp="291wafmzlke7q">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <li key={faq.question} data-id="element-87" data-mp="1z2xcozgde2zi" data-mpi={index}>
                <h3 data-id="element-88" data-mp="smv3cimuwm81">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-center justify-between gap-3 py-3.5 text-left transition-colors duration-150 ease-out hover:text-teal-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-600/50 sm:gap-4 sm:py-5" data-id="element-89" data-mp="snd51usafsnc">
                    <span className="font-display text-sm font-700 leading-snug text-teal-900 sm:text-base" data-id="element-90" data-mp="khtkfsvur535">
                      {faq.question}
                    </span>
                    <PlusIcon className={['h-4 w-4 shrink-0 text-teal-600 transition-transform duration-200 ease-out sm:h-5 sm:w-5', isOpen ? 'rotate-45' : ''].join(' ')} aria-hidden="true" data-id="element-91" data-mp="bhwrhf2fjk2a" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-92" data-mp="3k0cdlo03d0yx">
                  {isOpen ? <motion.div id={`faq-panel-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-93" data-mp="3nys5a574axio">
                      <p className="pb-4 pr-8 text-[0.8rem] leading-relaxed text-clay sm:pb-5 sm:pr-10 sm:text-sm" data-id="element-94" data-mp="1fpvj4zqh6ddu">
                        {faq.answer}
                      </p>
                    </motion.div> : null}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}